export const determineShippingOption = (
  allowIndividualShipping,
  isProductOneSize
) => {
  if (allowIndividualShipping) {
    return isProductOneSize ? '2' : '3';
  } else {
    return isProductOneSize ? '1' : '2';
  }
};

// We should be using RTK query / ReactQuery instead of yolo fetching
export const checkResponseOkay = response => {
  return response.ok ? response : Promise.reject(response);
};
